import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { CheckCircle2, XCircle, MailCheck } from "lucide-react";

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | ok | err
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("err"); setErr("Missing verification token."); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("err"); setErr(e.response?.data?.detail || "Verification failed."); });
  }, [params]);

  return (
    <Layout>
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        {state === "loading" && (
          <div data-testid="verify-loading">
            <MailCheck size={40} className="mx-auto text-accent mb-4" />
            <h1 className="font-display text-4xl">Verifying your email…</h1>
            <p className="text-muted-foreground mt-3">Hang tight.</p>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="verify-success">
            <CheckCircle2 size={48} className="mx-auto text-emerald-600 mb-4" />
            <div className="overline text-accent">All set</div>
            <h1 className="font-display text-5xl mt-3">Email confirmed</h1>
            <p className="text-muted-foreground mt-4">Thanks — your email is verified. You can now complete purchases and receive plan updates.</p>
            <Link to="/plans" className="inline-block mt-8 bg-accent text-accent-foreground px-6 py-3 hover:bg-accent/90 transition-colors" data-testid="verify-continue">Browse plans</Link>
          </div>
        )}
        {state === "err" && (
          <div data-testid="verify-error">
            <XCircle size={48} className="mx-auto text-destructive mb-4" />
            <div className="overline text-destructive">Could not verify</div>
            <h1 className="font-display text-4xl mt-3">Verification failed</h1>
            <p className="text-muted-foreground mt-4">{err}</p>
            <Link to="/" className="inline-block mt-8 border border-border px-6 py-3 hover:bg-accent hover:text-accent-foreground transition-colors" data-testid="verify-home">Back to home</Link>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default VerifyEmail;
